import { React, useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Tab,
  Tabs,
  Stack,
  Button,
  Pagination,
  Paper,
  InputAdornment,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

import { Add, Search } from "@mui/icons-material";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import VinculoCard from "../../components/VinculoCard";
import AdicionarVinculos from "./adicionarVinculo";

import api from "../../services/api";
import { FieldInputText, FieldSelect } from "../../components/Fields";
import { useLocation, useNavigate } from "react-router-dom";
import { permissionRoutes } from "../../utils/permissionRoutes";
import { getItemDecrypt } from "../../utils/cryptoData";

const theme = createTheme({
  typography: {
    welcome: {
      color: "#7D7D7D",
      fontSize: 20,
    },
  },
});

const styles = {
  title: {
    color: "#1E729F",
    fontWeight: "600",
  },
  subtitle: {
    color: "#7D7D7D",
    fontWeight: "500",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    padding: " 32px",
    justifyContent: "center",
    gap: "24px",
    width: "93%",
    boxShadow: "none",
  },
  addVinculos: {
    backgroundColor: "#1E729F",
    "&:hover": {
      backgroundColor: "#1E729F",
    },
    textTransform: "math-auto",
    fontFamily: "Nunito",
    fontSize: "18px",
    boxSizing: "border-box",
    height: "40px",
  },
  tabs: {
    ".css-heg063-MuiTabs-flexContainer": {
      justifyContent: "center  !important",
    },
  },
  tab: {
    textTransform: "none",
    fontFamily: "Nunito",
    lineHeight: "24px",
  },
  customGrid: {
    display: "grid",
    gridTemplateColumns: {
      xs: "repeat(auto-fit, minmax(252px, 1fr))",
      sm: "repeat(1, 1fr)",
      md: "repeat(2, 1fr)",
      lg: "repeat(3, 1fr)",
    },
    transition: "grid-template-columns 0.3s ease-in-out",
    gap: 3,
  },
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ padding: { xs: "24px 0px" } }}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ContainerVinculoCard = ({ data, handleRefresh, refresh }) => {
  return (
    <Box
      sx={{
        boxSizing: "border-box",
        height: "auto",
        width: "100%",
      }}
    >
      <VinculoCard
        vinculoId={data.id}
        statusVinculo={data.status}
        perfil={data.perfil}
        municipio={data.municipio}
        estabelecimentoDeSaude={data.estabelecimentoDeSaude}
        favorito={data.favorito}
        setRefresh={handleRefresh}
        refresh={refresh}
      />
    </Box>
  );
};

const ContainerMaxWidth = "1300px";
const Vinculos = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [arrVinculos, setArrVinculos] = useState();

  const [value, setValue] = useState(0);
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [totalDados, setTotalDados] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [qtdPorPagina, setQtdPorPagina] = useState(6);
  const [firstIndexPage, setFirstIndexPage] = useState(0);
  const [lastIndexPage, setLastIndexPage] = useState(0);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleRefresh = (value) => setRefresh(value);
  const [elementFirst, setElementFirst] = useState(1);
  const [elementLast, setElementLast] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [nome, setNome] = useState("");
  const [statusPerfil, setStatusPerfil] = useState("all");
  const [searchFilter, setSearchFilter] = useState("");
  const [loadingPermission, setLoadingPermission] = useState(true);

  useEffect(() => {
    setLoadingPermission(true);
    permissionRoutes(location.pathname).then((values) => {
      if (!values.hasPermission) {
        navigate(values.path);
      } else {
        setLoadingPermission(false);
      }
    });
  }, [location.pathname]);

  useEffect(() => {
    //Fazer a requisição para trazer os vínculos aqui

    const handleVinculos = async () => {
      let usuario = getItemDecrypt("usuario");

      setNome(usuario.no_nome_usuario.split(" ")[0]);
      try {
        const response = await api.post("/buscarVinculo", {
          id_usuario: usuario.co_id,
        });
        setArrVinculos(response.data);
        setTotalDados(response.data.count);
        setTotalPages(Math.ceil(response.data.count / qtdPorPagina));
      } catch (error) {
        console.error(error);
      }
    };

    handleVinculos();

    //deve ser a quantidade de vinculos trazidos na requisição
    if (totalDados < qtdPorPagina) {
      setElementLast(totalDados);
    } else {
      setElementLast(qtdPorPagina);
    }
  }, [open, refresh]);

  console.log("totalPages", totalPages);

  useEffect(() => {
    function changeIndexPage() {
      const first = page * qtdPorPagina - qtdPorPagina;
      setFirstIndexPage(first);
      const last = page * qtdPorPagina;
      setLastIndexPage(last);
    }

    changeIndexPage();
  }, [page]);

  const handleChangePage = (event, value) => {
    setPage(value);
    setElementFirst((value - 1) * qtdPorPagina + 1);
    if (value * qtdPorPagina > totalDados) {
      setElementLast(totalDados);
    } else {
      setElementLast(value * qtdPorPagina);
    }
  };

  const handleChange = (event, newValue) => {
    //Verificar se a quantidade de vinculos da aba selecionada é menor que o total de vinculos por página
    if (totalDados < qtdPorPagina) {
      setElementLast(totalDados);
    } else {
      setElementLast(qtdPorPagina);
    }
    setValue(newValue);
  };

  if (loadingPermission) {
    return (
      <Box sx={{ display: "flex" }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <Stack direction={"row"} justifyContent="center">
        <Paper style={styles.paper} sx={{ maxWidth: ContainerMaxWidth }}>
          <Box>
            <Box style={styles.title} fontSize={"40px"}>
              Olá, {nome}
            </Box>
            <Box>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                justifyContent={"space-between"}
                alignItems={{ xs: "flex-start", sm: "center" }}
              >
                <Box>
                  <Box
                    style={styles.subtitle}
                    fontSize={"22px"}
                    mb={{ xs: "10px", sm: "0px" }}
                  >
                    Selecione o vínculo
                  </Box>
                </Box>
                <Box>
                  <Button
                    variant="contained"
                    endIcon={<Add />}
                    onClick={handleOpen}
                    sx={styles.addVinculos}
                  >
                    Adicionar vínculo
                  </Button>
                </Box>
              </Stack>
            </Box>
          </Box>
          <Box
            sx={{
              boxShadow: "0px 0px 5px 4px rgba(217,217,217,0.3)",
              padding: 3,
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: "16px 24px",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              flexDirection={{ xs: "column", sm: "row" }}
            >
              <Stack width="100%" maxWidth={{ xs: "100%", sm: "500px" }}>
                <FieldInputText
                  label=""
                  value={searchFilter}
                  setValue={(val) => setSearchFilter(val.toUpperCase())}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Search sx={{ color: "rgba(62, 148, 194, 1)" }} />
                      </InputAdornment>
                    ),
                  }}
                  placeholder="Buscar por estabelecimento de saúde"
                />
              </Stack>
              <Stack width="100%" maxWidth={{ xs: "100%", sm: "360px" }}>
                <FieldSelect
                  value={statusPerfil}
                  setValue={(val) => setStatusPerfil(val === "" ? "all" : val)}
                  items={[
                    { id: "all", label: "Todos os status" },
                    {
                      id: 0,
                      label: "Aguardando homologação",
                    },
                    { id: 1, label: "Homologado" },
                    { id: 2, label: "Inativo" },
                  ].map((c) => {
                    return { id: c.id, label: c.label };
                  })}
                />
              </Stack>
            </Box>
            <Box sx={{ borderBottom: 1, borderColor: "divider", mt: 4 }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example center"
                style={styles.tabs}
                TabIndicatorProps={{
                  style: {
                    background: "rgba(30, 114, 159, 1)",
                  },
                }}
                sx={{
                  fontFamily: "Nunito",
                  fontWeight: 400,
                  ".Mui-selected": {
                    color: `rgba(30, 114, 159, 1)`,
                    fontWeight: 700,
                  },
                }}
              >
                <Tab
                  label={`Todos os vínculos (${
                    arrVinculos === undefined ? "" : arrVinculos.count
                  })`}
                  {...a11yProps(0)}
                  style={styles.tab}
                  sx={{ fontSize: { xs: "16px ", sm: "18px" } }}
                />
                <Tab
                  label={`Meus favoritos (${
                    arrVinculos === undefined
                      ? ""
                      : arrVinculos.vinculosTratados.filter(
                          (vinculo) => vinculo.favorito
                        ).length
                  })`}
                  {...a11yProps(1)}
                  style={styles.tab}
                  sx={{ fontSize: { xs: "16px ", sm: "18px" } }}
                />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <Stack sx={styles.customGrid}>
                {arrVinculos?.vinculosTratados
                  ?.slice(firstIndexPage, lastIndexPage)
                  .filter((vinc) =>
                    vinc.estabelecimentoDeSaude.includes(searchFilter)
                  )
                  .map((vinculo, key) => {
                    const shouldRenderCard =
                      (statusPerfil === 2 && vinculo.status === 2) ||
                      (statusPerfil === 1 && vinculo.status === 1) ||
                      (statusPerfil === 0 && vinculo.status === 0) ||
                      statusPerfil === "all";

                    return shouldRenderCard ? (
                      <ContainerVinculoCard
                        key={key}
                        data={vinculo}
                        handleRefresh={handleRefresh}
                        refresh={refresh}
                      />
                    ) : null;
                  })}
              </Stack>
            </TabPanel>

            <TabPanel value={value} index={1}>
              <Stack sx={styles.customGrid}>
                {arrVinculos?.vinculosTratados
                  ?.slice(firstIndexPage, lastIndexPage)
                  .filter(
                    (vinc) =>
                      vinc.estabelecimentoDeSaude.includes(searchFilter) &&
                      vinc.favorito === true
                  )
                  .map((vinculo, key) => {
                    const shouldRenderCard =
                      (statusPerfil === 2 && vinculo.status === 2) ||
                      (statusPerfil === 1 && vinculo.status === 1) ||
                      (statusPerfil === 0 && vinculo.status === 0) ||
                      statusPerfil === "all";

                    return shouldRenderCard ? (
                      <ContainerVinculoCard
                        key={key}
                        data={vinculo}
                        handleRefresh={handleRefresh}
                        refresh={refresh}
                      />
                    ) : null;
                  })}
              </Stack>
            </TabPanel>

            <Stack
              direction={{ md: "column", lg: "row" }}
              spacing={2}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Box>
                Mostrando {elementFirst} a {elementLast} de {totalDados}{" "}
                registros
              </Box>
              <Pagination
                sx={{
                  "& .MuiPaginationItem-root.Mui-selected": {
                    backgroundColor: "#3E94C2",
                  },
                }}
                count={totalPages}
                color={"primary"}
                page={page}
                onChange={handleChangePage}
              />
            </Stack>
          </Box>
        </Paper>
      </Stack>
      <AdicionarVinculos
        openModal={open}
        setOpenModal={handleClose}
        modalHeaderText="Adicionar vínculo"
        setRefresh={handleRefresh}
        refresh={refresh}
      ></AdicionarVinculos>
    </ThemeProvider>
  );
};

export default Vinculos;
